import {http} from "@/api/http";
import {API_URL} from "@/api/base";


    export async function getStrategies(company_id, query = '') {
        query = new URLSearchParams(query).toString()
        return await http.get(
            `${API_URL}/v1/strategy?company=${company_id}&${query}`        )
    }

export async function getStrategy(strategy_id) {
    return await http.get(
        `${API_URL}/v1/strategy/${strategy_id}`    )
}

export async function deleteStrategy(strategy_id) {
    return await http.delete(
        `${API_URL}/v1/strategy/${strategy_id}`    )
}

export async function updateStrategy(strategy_id, data) {
    return await http.put(
        `${API_URL}/v1/strategy/${strategy_id}`,
        data,
    )
}

export async function newStrategy(data) {
    console.log('aaa')
    return await http.post(
        `${API_URL}/v1/strategy`,
        data,
    )
}

export async function getStrategyLogs(strategy_id, page = 1, size = 10) {
    return await http.get(
        `${API_URL}/v1/strategy/${strategy_id}/logs?page=${page}&size=${size}`    )
}

export async function runStrategy(strategy_id) {
    return await http.post(
        `${API_URL}/v1/strategy/${strategy_id}/run`,
        {}    )
}

export async function downloadStrategyLogDetailsCsv(log_id) {
    return await http.get(
        `${API_URL}/v1/strategy/logs/${log_id}/details/csv`,
        {responseType: 'blob'}
    )
}

